/* Ezequiel Beauty — minimal theme JS. Vanilla, deferred, no third-party. */
(function () {
  'use strict';

  // Mobile nav toggle
  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('[data-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.hasAttribute('hidden');
      if (open) {
        nav.removeAttribute('hidden');
      } else {
        nav.setAttribute('hidden', '');
      }
      toggle.setAttribute('aria-expanded', String(open));
    });
  }

  // Portfolio category filter (data-attribute driven, no third-party)
  var filterBar = document.querySelector('[data-portfolio-filters]');
  var grid = document.querySelector('[data-portfolio-grid]');
  if (filterBar && grid) {
    filterBar.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-filter]');
      if (!btn) return;
      var filter = btn.getAttribute('data-filter');
      filterBar.querySelectorAll('[data-filter]').forEach(function (b) {
        b.classList.toggle('chip--on', b === btn);
      });
      grid.querySelectorAll('[data-category]').forEach(function (item) {
        var show = filter === '*' || item.getAttribute('data-category') === filter;
        item.hidden = !show;
      });
    });
  }

  // Auto-submit forms (e.g. collection sort select) on change
  document.querySelectorAll('[data-auto-submit]').forEach(function (form) {
    form.addEventListener('change', function () { form.submit(); });
  });

  // Live cart count (standard /cart.js — no third-party flow)
  function refreshCartCount() {
    var el = document.querySelector('[data-cart-count]');
    if (!el) return;
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (cart) el.textContent = cart.item_count;
      })
      .catch(function () { /* non-fatal */ });
  }
  refreshCartCount();
})();
